/**
 * Application Constants
 * True constants that don't change across environments
 * These are business logic constants, not configuration
 */

export const COMPANY_INFO = {
  name: 'TimePayment',
  fullName: 'TimePayment Corp.',
  address: {
    street: '400 TradeCenter, Suite 6950',
    city: 'Woburn',
    state: 'MA',
    zipCode: '01801-7452',
    phone: '781-994-4800'
  }
};

export const customerServicePhone = '8778683800';

// Legal text constants
export const LegalOptInText = `You understand by clicking on the I AGREE button immediately following this notice, you are providing written instructions to TimePayment under the Fair Credit Reporting Act authorizing TimePayment to obtain information from your personal credit report or other information from Experian. You authorize TimePayment to obtain such information solely for this lease application.`;

export const LegalOptInTextAdditional = `I expressly agree TimePayment Corp., its authorized affiliates, assigns and agents may assess my credit worthiness for an amount above the initial equipment cost. I understand TimePayment Corp., its authorized affiliates, assigns and agents may offer me a Lease amount over the sum requested, depending on my credit worthiness.`;

export const IsSignatureAcceptedText = ` By checking this box and typing my name, I am electronically signing this credit application and it shall be treated as an original signature`;
